import { render } from "./CharlaAboutPopup.vue?vue&type=template&id=48db6e44&scoped=true"
import script from "./CharlaAboutPopup.vue?vue&type=script&lang=js"
export * from "./CharlaAboutPopup.vue?vue&type=script&lang=js"

import "./CharlaAboutPopup.vue?vue&type=style&index=0&id=48db6e44&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48db6e44"]])

export default __exports__